import warrantyFormAssignProductSelect from "./warrantyFormAssignProductSelect.container";

export default warrantyFormAssignProductSelect;
